import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateServiceordreComponent } from './components/create-serviceordre/create-serviceordre.component';
import { SearchComponent } from './components/search/search.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SearchComponent,
  },
  {
    path: 'ordre/:serviceaftaleNo',
    pathMatch: 'full',
    component: CreateServiceordreComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
